module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/related/ko_2-ba66ffcfba74c4aab1175063d9899329.jpg";